const SectionTitle = ({ title, subtitle }) => {
    return (
      <div className="mb-12 text-center">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">
          {title}
        </h2>
        {subtitle && (
          <p className="text-lg text-gray-600 dark:text-gray-300">{subtitle}</p>
        )}
      </div>
    );
  };
  
  export default SectionTitle;